import React from 'react';
import { useNavigate } from 'react-router';
import MenuItem from '@mui/material/MenuItem';
import { StyledMenu } from './Header';
import { useTranslation } from 'react-i18next';
import { environment } from '../../../../../apps/table-tuck-web/src/environments/environment';
import { getFontFamily } from '../../../../../apps/table-tuck-web/src/app/Utils/fontLoader';

export function FattyPattyMobileMenu({
  anchorEl,
  openMenu,
  handleCloseMenu,
  activeLink,
  env,
  restaurantId,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const isFattyPatty =
    restaurantId === 'fattyPattyDev' || restaurantId === 'fattyPatty';

  return (
    <StyledMenu
      id="demo-customized-menu"
      anchorEl={anchorEl}
      open={openMenu}
      onClose={handleCloseMenu}
      PaperProps={{
        style: {
          width: 'full',
          maxWidth: 'full',
          left: 0,
          right: 0,
        },
      }}
      MenuListProps={{
        'aria-labelledby': 'demo-customized-button',
        sx: { padding: '2px 0' },
      }}
    >
      <MenuItem
        onClick={() => {
          navigate('/');
          handleCloseMenu();
        }}
        disableRipple
        sx={{
          fontWeight: activeLink === '/' ? 700 : 400,
          backgroundColor:
            activeLink === '/' ? `${env.mainColor}15` : 'transparent',
          color: activeLink === '/' ? env.mainColor : 'inherit',
          padding: '8px 16px',
        }}
      >
        {t('home')}
      </MenuItem>

      {isFattyPatty && (
        <MenuItem
          onClick={() => {
            navigate('/menu');
            handleCloseMenu();
          }}
          disableRipple
          sx={{
            fontWeight: activeLink === '/menu' ? 700 : 400,
            backgroundColor:
              activeLink === '/menu' ? `${env.mainColor}15` : 'transparent',
            color: activeLink === '/menu' ? env.mainColor : 'inherit',
            padding: '8px 16px',
          }}
        >
          {t('menuNav')}
        </MenuItem>
      )}

      {isFattyPatty && (
        <MenuItem
          onClick={() => {
            navigate('/aboutus');
            handleCloseMenu();
          }}
          disableRipple
          sx={{
            fontWeight: activeLink === '/aboutus' ? 700 : 400,
            backgroundColor:
              activeLink === '/aboutus' ? `${env.mainColor}15` : 'transparent',
            color: activeLink === '/aboutus' ? env.mainColor : 'inherit',
            padding: '8px 16px',
          }}
        >
          {t('about')}
        </MenuItem>
      )}

      {isFattyPatty && (
        <MenuItem
          onClick={() => {
            navigate('/locations');
            handleCloseMenu();
          }}
          disableRipple
          sx={{
            fontWeight: activeLink === '/locations' ? 700 : 400,
            backgroundColor:
              activeLink === '/locations' ? `${env.mainColor}15` : 'transparent',
            color: activeLink === '/locations' ? env.mainColor : 'inherit',
            padding: '8px 16px',
          }}
        >
          {t('locations')}
        </MenuItem>
      )}

      {isFattyPatty && (
        <MenuItem
          onClick={() => {
            navigate('/catering');
            handleCloseMenu();
          }}
          disableRipple
          sx={{
            fontWeight: activeLink === '/catering' ? 700 : 400,
            backgroundColor:
              activeLink === '/catering' ? `${env.mainColor}15` : 'transparent',
            color: activeLink === '/catering' ? env.mainColor : 'inherit',
            padding: '8px 16px',
          }}
        >
          {t('catering')}
        </MenuItem>
      )}

      {!isFattyPatty && (
        <MenuItem
          onClick={() => {
            navigate('/restaurants');
            handleCloseMenu();
          }}
          disableRipple
          sx={{
            fontWeight: activeLink === '/restaurants' ? 700 : 400,
            backgroundColor:
              activeLink === '/restaurants' ? `${env.mainColor}15` : 'transparent',
            color: activeLink === '/restaurants' ? env.mainColor : 'inherit',
            padding: '8px 16px',
          }}
        >
          {t('restaurants')}
        </MenuItem>
      )}

      <MenuItem
        onClick={() => {
          navigate('/contactus');
          handleCloseMenu();
        }}
        disableRipple
        sx={{
          fontWeight: activeLink === '/contactus' ? 700 : 400,
          backgroundColor:
            activeLink === '/contactus' ? `${env.mainColor}15` : 'transparent',
          color: activeLink === '/contactus' ? env.mainColor : 'inherit',
          padding: '8px 16px',
        }}
      >
        {t('contact')}
      </MenuItem>

      <MenuItem
        onClick={() => {
          navigate('/deals');
          handleCloseMenu();
        }}
        disableRipple
        sx={{
          fontWeight: activeLink === '/deals' ? 700 : 400,
          backgroundColor:
            activeLink === '/deals' ? `${env.mainColor}15` : 'transparent',
          color: activeLink === '/deals' ? env.mainColor : 'inherit',
          padding: '8px 16px',
        }}
      >
        Deals
      </MenuItem>

      <MenuItem
        onClick={() => {
          window.open(
            'https://squareup.com/gift/NBFYWH04EDE44/order',
            '_blank'
          );
          handleCloseMenu();
        }}
        disableRipple
        sx={{
          padding: '8px 16px',
        }}
      >
        Gift Cards
      </MenuItem>

      <MenuItem
        onClick={() => {
          navigate('/careers');
          handleCloseMenu();
        }}
        disableRipple
        sx={{
          fontWeight: activeLink === '/careers' ? 700 : 400,
          backgroundColor:
            activeLink === '/careers' ? `${env.mainColor}15` : 'transparent',
          color: activeLink === '/careers' ? env.mainColor : 'inherit',
          padding: '8px 16px',
        }}
      >
        Join Team
      </MenuItem>
    </StyledMenu>
  );
}

export default FattyPattyMobileMenu;
